import {connect} from "react-redux";
import React from "react";
import {getActiveSearch, getActiveItineraries} from '../../../@opentripplanner/core-utils/src/state'
import {itineraryToTransitive} from '../../../@opentripplanner/core-utils/src/map'
import {Layer, Source} from "react-map-gl";
import {getGeojsonPoint6} from "../../../actions/map";
import MapIconLayer from "../mapIconLayer";
import {JOURNEY_MODES} from '../../../constants'

function TransitiveOverlay(props) {
  const {activeItinerary, routingType, transitiveData} = props;

  return (
    <div key={"transitive_" + routingType + activeItinerary}>
      <MapIconLayer/>
      {(transitiveData && transitiveData.journeys) && transitiveData.journeys.map(
        (journey, journeyIndex) => (
          <div key={journey.journey_id}>
            {
              journey.segments.map((segment, segmentIndex) => {
                const segmentType = segment.type;
                switch (segmentType) {
                  case JOURNEY_MODES.walk:
                  case JOURNEY_MODES.car:
                  case JOURNEY_MODES.bicycle:
                    return (
                      <div key={`${segmentType}_${segmentIndex}`}>
                        {
                          segment.streetEdges.map((streetEdge, streetEdgeIndex) => (
                            <div key={journey.journey_id + segmentIndex + streetEdgeIndex}>
                              {transitiveData.streetEdges[streetEdge]?.geometry?.points6 &&
                              <div key={`${segmentType}_line${journey.journey_id}${segmentIndex}${streetEdgeIndex}`}>
                                <Source id={"leg_line_" + journey.journey_id + segmentIndex + streetEdgeIndex}
                                        type="geojson"
                                        data={getGeojsonPoint6(transitiveData.streetEdges[streetEdge].geometry.points6)}/>
                                <Layer type="line"
                                         source={"leg_line_" + journey.journey_id + segmentIndex + streetEdgeIndex}
                                         id={'routeLayer_' + journey.journey_id + segmentIndex + streetEdgeIndex}
                                         paint={{
                                           'line-width': 5,
                                           'line-dasharray': segmentType == JOURNEY_MODES.walk ? [2, 2, 2, 2] : [],
                                           'line-color': '#000000'
                                         }}
                                  />
                                </div>}
                              </div>
                            ))
                          }
                        </div>
                      );
                    case "TRANSIT":
                      return (
                        <div key={"transit_" + segmentIndex}>
                          {
                            segment.patterns.map((pattern, patternIndex) => {
                              let transitKey = journey.journey_id + segmentIndex + patternIndex;
                              let transitivePattern = transitiveData.patterns.find(pa => pa.pattern_id === pattern.pattern_id);

                              if (transitivePattern) {
                                let route = transitiveData.routes.find(ro => ro.route_id === transitivePattern.route_id);
                                return (<div key={transitKey}>
                                    {
                                      transitivePattern.stops.map((stop, stopIndex) => (
                                        stop.geometry && <div key={"transit_line_" + transitKey + stopIndex}>
                                          <Source id={"line_" + transitKey + stopIndex} type="geojson"
                                                  data={getGeojsonPoint6(stop.geometry)}/>
                                          <Layer type="line" source={"line_" + transitKey + stopIndex}
                                                 id={'routeLayer_' + transitKey + stopIndex}
                                                 paint={{'line-color': `#${route.route_color}`, 'line-width': 8}}
                                                 layout={{'line-join': "round"}}
                                          />
                                        </div>
                                      ))
                                    }
                                  </div>
                                )
                              }
                            })
                          }
                        </div>
                      );
                    default:
                      break;
                  }
                }
              )
            }
          </div>
        )
      )}
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  const activeSearch = getActiveSearch(state.otp);
  let transitiveData = null;
  if (
    activeSearch &&
    activeSearch.query.routingType === 'ITINERARY' &&
    activeSearch.response &&
    activeSearch.response.plan && (activeSearch.activeItinerary != null)
  ) {
    const itins = getActiveItineraries(state.otp);
    transitiveData = itineraryToTransitive(itins[activeSearch.activeItinerary])
  } else if (
    activeSearch &&
    activeSearch.response &&
    activeSearch.response.otp
  ) {
    transitiveData = activeSearch.response.otp;
  }

  return {
    activeItinerary: activeSearch && activeSearch.activeItinerary,
    routingType: activeSearch && activeSearch.query && activeSearch.query.routingType,
    transitiveData,
    visible: true
  }
};

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(TransitiveOverlay)